module.exports = __webpack_public_path__ + "img/logo.e31d475a.png";